import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { startSoundDirector } from './sound/director.js';
import { startVoice } from './sound/voice.js';
import './design/tokens.css';
import './design/global.css';

// Before the first render: the director must see the store's very first
// transitions, and the unlock listener must catch the very first tap.
startSoundDirector();
startVoice();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
